import Vue from 'vue'
import Axios from 'axios'
import Store from '@/globals/store'
import Router from 'vue-router'
import RegisterSimpleRegistration from '@/views/register/SimpleRegistration'
import SecretaryConfirmation from '@/views/register/SecretaryConfirmation'
import Register from './register'
import Doctor from './doctor'
import Secretary from './secretary'
import SecretaryDoctorSelect from '@/views/secretary/DoctorSelect'
import Home from '@/views/Home'
import EmailConfirm from '@/views/register/EmailConfirm'
import Login from '@/views/Login'
import Logout from '@/views/Logout'
import LoginForm from '@/components/form/login'
import RecoveryForm from '@/components/form/recovery'
import ResetForm from '@/components/form/newPassword'
import Sync from '@/views/Sync'
import Maintenance from '@/views/Maintenance'
import TermsOfUse from '@/views/TermsOfUse'
import AgendaOnline from '@/views/AgendaOnline'
import MedicalExamRequest from '@/views/MedicalExamRequest'
import customRegistrationRoutes from '@/data/miscData/customRegistrationRoutes'
import customLoginRoutes from '@/data/miscData/customLoginRoutes'

const loginRoutes = customLoginRoutes.map((route) => {
  const name = route.name.charAt(0).toUpperCase() + route.name.slice(1)
  const customRoute = {
    path: route.path,
    name: `LoginForm${name}`,
    component: LoginForm,
    meta: {
      name: route.name,
      hasLogo: route.hasLogo,
      image: 'image' in route ? route.image : null,
      ...route.meta
    }
  }

  return customRoute
})

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'Index',
    component: Home
    // redirect: { to: 'https://drconecta.com.br/' }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance
  },
  {
    path: '/login/',
    name: 'Login',
    component: Login,
    redirect: { name: 'LoginForm' },
    children: [
      {
        path: '',
        name: 'LoginForm',
        component: LoginForm,
        children: [...loginRoutes]
      },
      {
        path: 'recovery',
        name: 'LoginRecovery',
        component: RecoveryForm
      },
      {
        path: 'reset/:token',
        name: 'LoginReset',
        component: ResetForm
      }
    ]
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout
  },
  {
    path: '/register/simple',
    name: 'RegisterSimpleRegistration',
    component: RegisterSimpleRegistration
  },
  {
    path: '/register/secretary/:token',
    name: 'RegisterSecretary',
    component: SecretaryConfirmation
  },
  {
    path: '/register/email_confirmation/:token',
    name: 'RegisterEmailConfirm',
    component: EmailConfirm
  },
  {
    path: '/register/user/:id?',
    name: 'RegisterUserDoctorRegistration',
    component: () => import('../views/register/UserDoctorRegistration.vue')
  },
  Register,
  Doctor,
  {
    path: '/secretary/doctor_select',
    name: 'SecretaryStart',
    component: SecretaryDoctorSelect
  },
  Secretary,
  {
    path: '/sync/:service',
    name: 'Sync',
    component: Sync
  },
  {
    path: '/sync/:service/:status',
    name: 'SyncStatus',
    component: Sync
  },

  {
    path: '/terms-of-use',
    name: 'TermsOfUse',
    component: TermsOfUse
  },
  {
    path: '/public/doctor/:uuid',
    name: 'AgendaOnline',
    component: AgendaOnline
  },
  {
    path: '/medical-exam',
    name: 'MedicalExamRequest',
    component: MedicalExamRequest
  },
  {
    path: '/validacao/:type?/:token?',
    name: 'FileValidation',
    component: () => import('@/views/FileValidation.vue')
  }
]

// Adiciona endereços de registro customizados
const customRoutes = customRegistrationRoutes.map((route) => {
  const name = String(route.name.charAt(0).toUpperCase() + route.name.slice(1))
  const customRoute = {
    path: route.path,
    name: `RegisterSimpleRegistration${name}`,
    component: RegisterSimpleRegistration,
    meta: {
      name: route.name,
      hasLogo: route.hasLogo,
      image: 'image' in route ? route.image : null,
      ...route.meta
    }
  }

  return customRoute
})

routes = [...routes, ...customRoutes]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const outerRoutes = [
    '',
    '/',
    'logout',
    'register',
    'admin-login',
    'login',
    'sync',
    'maintenance',
    'terms-of-use',
    'public',
    'medical-exam',
    'validacao',
    ...customRegistrationRoutes.map(route => String(route.path).split('/')[1])
  ]

  if ((to.name === 'DoctorReports' || /doctorfinances/gmi.test(to.name)) && Store.getters['getPlan'].isPro) {
    if (!from.name) {
      next({ name: 'DoctorAgenda' })
    }

    Store.dispatch('togglePlanModal', true)
    return
  }

  // if (to.name === 'DoctorAppIntegrationHealthPlace' && Store.getters['getPlan'].isPro) {
  //   if (!from.name) {
  //     next({ name: 'DoctorAppIntegrationFinance' })
  //   }

  //   Store.dispatch('togglePlanModal', true)
  //   return
  // }

  window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  Store.dispatch('toggleProgress', true)

  if (outerRoutes.indexOf(to.path.split('/')[1]) === -1) {
    if (!Store.getters.getRoles) {
      router.replace({name: 'Index'})
      return
    }
    if (Store.getters.getRoles.indexOf('ROLE_DOCTOR_PRO') === -1 && Store.getters.getRoles.indexOf('ROLE_DOCTOR_PREMIUM') === -1 && Store.getters.getRoles.indexOf('ROLE_SECRETARY') === -1) {
      Store.dispatch('setModalAlert', {
        title: 'Erro de perfil de usuário',
        body: 'Acesso não permitido',
        size: 'md',
        active: true,
        callback: function (next) {
          this.$router.replace({name: 'Index'})
        }
      })
    } else if (Store.getters.$_checkAuth) {
      next()
    } else {
      Store.dispatch('setModalAlert', {
        title: 'Erro de autenticação',
        body: 'Seu acesso expirou. Por favor realize o login novamente',
        size: 'md',
        active: true,
        callback: function (next) {
          this.$router.replace({name: 'Index'})
        }
      })
    }
    Store.getters.getCancelToken.cancel('canceled')
    Store.dispatch('setCancelToken', Axios.CancelToken.source())
  } else {
    next()
  }
})

export default router
